/**
 * Crea la disposición del tragamonedas
 * @param {*} scene 
 */
export function crearCajaTragamonedas(scene) {
  const cajaTragamonedas = scene.add.image(375, 225, "cajaTragamonedas");
  cajaTragamonedas.setDepth(200);
}